/*jshint globalstrict: false*/

export default {
    methods: {
        formatPrice(price, hideDecimals = false) {
            const fractionDigits = hideDecimals ? 0 : 2;

            return '$' + (price * 0.01).toFixed(fractionDigits);
        },
        humanizeString(str, capitalizeFirstLetter = false) {
            if (!str) {
                return str;
            }

            str = str.replaceAll('_', ' ');

            if (str.length && capitalizeFirstLetter) {
                str = str.charAt(0).toUpperCase() + str.slice(1);
            }

            return str;
        },
        titleizeString(str) {
            return this.humanizeString(str).replace(/\b\w/g, l => l.toUpperCase())
        },
        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }
};
